import { useStore } from 'vuex'
import { computed, onMounted, ref } from 'vue'
import debounce from 'foundation/js/debounce'

export default {
    name: 'HeroGeneralSearch',
    props: {
        guids: {
            type: Array,
            required: true
        },
        primaryTagsDisplayed: {
            type: Number,
            required: true
        }
    },
    setup(props) {
        const store = useStore()
        const hasTags = ref(false)

        // more filter button status linked to whether overlay is open with FilterOverlay
        const tagMoreFiltersButtonStatus =  computed(() => store.state.main.page_overlay_content === "FilterOverlay")
        
        const inputText = computed({
            get: () => store.state.search.queries[props.guids[0]] ?? '',
            set: (v) => {
                if (props.guids && props.guids.length) {
                    props.guids.forEach((g) =>
                        store.dispatch('search/setSearchQuery', {
                            guid: g,
                            query: v
                        })
                    )
                }
            }
        })
        const tagDisplay = computed(() => {
            let allPrimaryTags = []
            props.guids.forEach((guid) => {
                let values = store.getters['search/allPrimaryTags'](guid)
                if (values) {
                    allPrimaryTags.push(...values)
                }
            })
            // Remove duplicate tags by facetId property
            const uniquePrimaryTags = [
                ...new Map(
                    allPrimaryTags.map((tag) => [tag['facetId'], tag])
                ).values()
            ]
            return uniquePrimaryTags.slice(0, props.primaryTagsDisplayed)
        })

        const termInput = debounce(() => {
            props.guids.forEach((g) => {
                store.dispatch('search/performSearch', {
                    guid: g,
                    query: inputText.value
                })
            })
        }, 500)

        const filterOnTag = function (tag) {
            props.guids.forEach((g) => {
                store.dispatch('search/performSearch', {
                    guid: g,
                    query: inputText.value,
                    facet: tag
                })
            })
        }

        const startFilterOverlay = function (e) {

            props.guids.forEach((g) => {
                store.dispatch('main/openPageOverlay', {
                    overlayContent: 'FilterOverlay',
                    returnTarget: e.currentTarget
                })
            })

            console.log('store.state.main.page_overlay_content', store.state.main.page_overlay_content)
            console.log('store.state.main.page_overlay_content === "FilterOverlay" ', store.state.main.page_overlay_content === "FilterOverlay" )
            console.log('tagMoreFiltersButtonStatus.value ', tagMoreFiltersButtonStatus.value )
        }

        onMounted(() => {
            store.commit('search/set_filter_overlay_scopes', props.guids)
            hasTags.value = true
        })

        return {
            inputText,
            filterOnTag,
            startFilterOverlay,
            tagDisplay,
            termInput,
            hasTags,
            tagMoreFiltersButtonStatus 
        }
    }
}
